import button from './el-button'
import carousel from './el-carousel'
import checkboxGroup from './el-checkbox-group'
import input from './el-input'
import radioGroup from './el-radio-group'
import select from './el-select'
import upload from './el-upload'

export default {
    "el-button": button,
    "el-carousel": carousel,
    "el-checkbox-group": checkboxGroup,
    "el-input": input,
    "el-radio-group": radioGroup,
    "el-select": select,
    "el-upload": upload
}